import { type GameObj } from 'kaplay'
import type { Ingredient } from '../constants/ingredients'
import k from '../constants/k'
import { ingredients, inCauldron, times } from '../state/globals'
import { ingredientOptions } from '../constants/ingredients'
import { PotionRecipe, potions } from '../constants/potions'
import { w, h, score } from '../state/globals'

ingredientOptions.forEach((ingredient) => {
  k.loadSprite(ingredient, `sprites/ingredients/${ingredient}.png`)
})

potions.forEach((potion) => {
  k.loadSprite(potion.name, `sprites/potions/${potion.name}.png`)
})

k.loadSprite('failedPotion', 'sprites/potions/failed.png')

const findPotion = (): PotionRecipe => {
  const potion =
    potions.find((p) =>
      p.ingredients.every((ingredient, i) => ingredient === inCauldron[i])
    ) ?? null
  if (potion) potion.found = true
  return potion
}

const potionsFound = (): boolean => {
  const test = potions.filter((potion) => potion.found === true)
  return test.length === potions.length
}

export const addIngredient = (
  inventory: Array<GameObj>,
  ingredient: Ingredient
) => {
  for (let i = 0; i < inventory.length; i++) {
    if (!ingredients[i] && !ingredients.includes(ingredient)) {
      ingredients[i] = ingredient
      k.play('pop')

      return inventory[i].add([
        k.sprite(ingredient),
        k.anchor('center'),
        k.area(),
        ingredient
      ])
    }
  }
}

export const removeIngredient = (
  inventory: Array<GameObj>,
  ingredient: Ingredient
) => {
  const index = ingredients.indexOf(ingredient)
  const obj = inventory[index].children?.[0]
  inventory[index].remove(obj)
  ingredients[index] = undefined
}

export const initializeIngredients = (
  inventory: Array<GameObj>,
  cursor: GameObj
) => {
  const currentScene = k.getSceneName()
  let holdingIngredient: GameObj | null = null

  ingredients.forEach((ingredient, i) => {
    if (ingredient) {
      const ingredientObj = inventory[i].add([
        k.sprite(ingredient),
        k.anchor('center'),
        k.area(),
        k.pos(),
        ingredient
      ])

      ingredientObj.onClick(() => {
        if (currentScene === 'room') {
          removeIngredient(inventory, ingredient)
          holdingIngredient = k.add([
            k.sprite(ingredient),
            k.anchor('center'),
            ingredient
          ])
          holdingIngredient.pos = k.mousePos()
        }
      })
    }
  })

  k.onMouseRelease(() => {
    if (holdingIngredient) {
      const ingredientName = holdingIngredient.tags[1] as Ingredient

      cursor.play('default')
      const cauldron = k.get('cauldron')[0]
      const progress = cauldron.get('progress')[0]

      if (cauldron.isHovering() && inCauldron.length < 3) {
        inCauldron.push(ingredientName)
        k.play('pop')
        inCauldron.sort()
        progress.play(inCauldron.length.toString())
      } else {
        const test = addIngredient(inventory, ingredientName)
        test.onClick(() => {
          if (currentScene === 'room') {
            removeIngredient(inventory, ingredientName)
            holdingIngredient = k.add([
              k.sprite(ingredientName),
              k.anchor('center'),
              ingredientName
            ])
            holdingIngredient.pos = k.mousePos()
          }
        })
      }

      if (inCauldron.length === 3) {
        const potion = findPotion()
        inCauldron.length = 0
        progress.play(inCauldron.length.toString())

        if (potion) {
          const potionObj = k.add([
            k.sprite(potion.name),
            k.pos(w / 2, h / 2),
            k.anchor('center'),
            k.scale(0),
            k.area()
          ])
          k.play('sparkle')

          k.tween(
            k.vec2(0),
            k.vec2(1.8),
            1,
            (v) => {
              potionObj.scale = v
            },
            k.easings.linear
          )

          potionObj.onMouseDown(() => k.destroy(potionObj))
          score.potionsMade += 1
          if (potionsFound()) {
            times.endTime = Date.now()
            k.go('completed')
          }
        } else {
          score.mistakes += 1
          const failedPotion = k.add([
            k.sprite('failedPotion'),
            k.pos(w / 2, h / 2),
            k.anchor('center'),
            k.scale(0),
            k.area()
          ])
          k.play('explode')
          k.tween(
            k.vec2(0),
            k.vec2(1.8),
            1,
            (v) => {
              failedPotion.scale = v
            },
            k.easings.linear
          )
          failedPotion.onMouseDown(() => k.destroy(failedPotion))
        }
      }

      k.destroy(holdingIngredient)
      holdingIngredient = null
    }
  })

  k.onMouseMove(() => {
    if (holdingIngredient) {
      holdingIngredient.pos = k.mousePos()
    }
  })

  cursor.onUpdate(() => {
    if (holdingIngredient) {
      cursor.play('drag')
    }
  })
}
